/**
 * Newsletter module - aggregates all newsletter functionality
 * @module lib/newsletter
 */

const { resolveNewsletterContext } = require('../utils/brandContext');
const { buildNewsletterIframeUrl, buildNewsletterSubscribeUrl, buildNewsletterPreviewUrl } = require('./urls');
const { ensureNewsletterStyles } = require('./styles');
const { ensureNewsletterIframeResizer, createNewsletterIframeModule, createNewsletterModule } = require('./iframe');
const { submitNewsletterForm, ensureNewsletterEventDelegation } = require('./form');

module.exports = {
  resolveNewsletterContext,
  buildNewsletterIframeUrl,
  buildNewsletterSubscribeUrl,
  buildNewsletterPreviewUrl,
  ensureNewsletterStyles,
  ensureNewsletterIframeResizer,
  createNewsletterIframeModule,
  createNewsletterModule,
  submitNewsletterForm,
  ensureNewsletterEventDelegation
};
